import dayjs from 'dayjs';

/**
 * ISO-8601（如 2026-09-10T08:00:05，**无时区后缀**）→ `yyyy-MM-dd HH:mm:ss`
 * ⚠️ 不能用 `new Date(str)` 直接解析（会被当成本地时区），统一走这里。
 */
export function formatIsoDateTime(value?: string | null) {
  if (!value) {
    return '-';
  }
  const date = dayjs(value);
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : value;
}

/** `yyyyMMdd` → `yyyy-MM-dd`（趋势图横轴） */
export function formatCompactDate(value?: string | null) {
  if (!value || value.length !== 8) {
    return value ?? '';
  }
  return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}`;
}

/** 指标值 + 单位：PERCENT → `%`，HOURS → `h`；value 原样输出，不做小数位格式化 */
export function formatMetricValue(value?: string | null, unit?: Dashboard.TikTokUS.ValueUnit) {
  if (value === undefined || value === null || value === '') {
    return '-';
  }
  if (unit === 'HOURS') {
    return `${value}h`;
  }
  if (unit === 'PERCENT') {
    return `${value}%`;
  }
  return value;
}

/** 同类百分位等「纯数字字符串」补 `%` */
export function formatPercent(value?: string | null) {
  if (!value) {
    return '-';
  }
  return `${value}%`;
}

/** 数值化（图表 / 比较用）；非法值返回 null */
export function toNumber(value?: string | number | null) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}
